// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"59e87294","745":"640d73cf","756":"49be544b"}[chunkId] + ".css";
};